/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimeInterval
 */
export interface TimeInterval {
    /**
     * 
     * @type {number}
     * @memberof TimeInterval
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof TimeInterval
     */
    interval: TimeIntervalIntervalEnum;
}


/**
 * @export
 */
export const TimeIntervalIntervalEnum = {
    Seconds: 'seconds',
    Minutes: 'minutes',
    Days: 'days',
    Weeks: 'weeks',
    Months: 'months',
    Years: 'years'
} as const;
export type TimeIntervalIntervalEnum = typeof TimeIntervalIntervalEnum[keyof typeof TimeIntervalIntervalEnum];


/**
 * Check if a given object implements the TimeInterval interface.
 */
export function instanceOfTimeInterval(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "interval" in value;

    return isInstance;
}

export function TimeIntervalFromJSON(json: any): TimeInterval {
    return TimeIntervalFromJSONTyped(json, false);
}

export function TimeIntervalFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeInterval {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'interval': json['interval'],
    };
}

export function TimeIntervalToJSON(value?: TimeInterval | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'interval': value.interval,
    };
}

